import { motion } from 'framer-motion'
import React, { forwardRef } from 'react'
import styled, { keyframes, css } from 'styled-components'
import {
  space,
  position,
  color,
  typography,
  border,
  layout,
  flexbox,
  grid,
  variant,
  shadow,
  background,
} from 'styled-system'

const zoomIn = keyframes`
  0% {
    transform: scale(0);
  }
  50% {
    transform: translate(-50%, -50%) scale(0);
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
  }
`

const zoomOut = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    transform: translate(-50%, -50%) scale(0);
  }
`

const animationStyles = css`
  animation: ${({ isMounted }) =>
    isMounted
      ? css`
          ${zoomIn} 1.5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards
        `
      : css`
          ${zoomOut} .5s cubic-bezier(0.165, 0.840, 0.440, 1.000) forwards
        `};
`

export const StyledBox = styled.div`
  ${background}
  ${position}
  ${flexbox}
  ${grid}
  ${space}
  ${color}
  ${layout}
  ${typography}
  ${border}
  ${variant}
  ${shadow}
  ${({
  filter,
  transform,
  cursor,
  textTransform,
  borderImage,
  borderImageOutset,
  borderImageRepeat,
  borderImageSlice,
  borderImageSource,
  borderImageWidth
}) => ({
  filter,
  transform,
  cursor,
  textTransform,
  borderImage,
  borderImageOutset,
  borderImageRepeat,
  borderImageSlice,
  borderImageSource,
  borderImageWidth
})}

  ${({ fadeIn }) => fadeIn && animationStyles}
  ${({ pointerEvents }) => pointerEvents && `pointer-events: ${pointerEvents};`}
`

const Box = forwardRef(({ children, animated, ...props }, ref) => {
  return (
    <StyledBox
      ref={ref}
      as={animated && motion.div}
      {...props}
    >
      {children}
    </StyledBox>
  )
})

export default Box
export { Box }
